import type { Carrier, Tracking } from '../types/account'

/** De vervoerders waar Sarah mee verstuurt. Nieuwe vervoerder = hier één regel erbij. */
export const carriers: readonly Carrier[] = ['PostNL', 'DHL']

/**
 * Publieke volgpagina per vervoerder. Werkt zonder postcode; met postcode toont
 * PostNL direct de details. Controleer deze adressen bij livegang: vervoerders
 * verhuizen hun volgpagina af en toe.
 */
export function trackingUrl(t: Tracking, postcode?: string): string {
  const code = encodeURIComponent(t.code)
  switch (t.carrier) {
    case 'PostNL':
      return postcode
        ? `https://jouw.postnl.nl/track-and-trace/${code}-NL-${encodeURIComponent(postcode.replace(/\s+/g, '').toUpperCase())}`
        : `https://jouw.postnl.nl/track-and-trace/${code}`
    case 'DHL':
      return `https://my.dhlecommerce.nl/home/tracktrace/${code}`
  }
}

/** Codes worden vaak geplakt met spaties of kleine letters: één vorm bewaren. */
export const normalizeTrackingCode = (raw: string) => raw.replace(/\s+/g, '').toUpperCase()

/** Een barcode is minstens 8 tekens, letters en cijfers. Leeg mag: dan zonder code verzenden. */
export const isValidTrackingCode = (code: string) => /^[A-Z0-9]{8,40}$/.test(code)
